/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'virtual-service';
const componentName = 'virtual-service-faults';
const prefix = `${moduleName}.${componentName}`;

export const virtualServiceFaultTitle = `${prefix}.virtualServiceFaultsTitle`;
export const serverFaultsTitle = `${prefix}.serverFaultsTitle`;

export const ENGLISH = {
    [virtualServiceFaultTitle]: 'Virtual Service Fault',
    [serverFaultsTitle]: 'Server Faults',
};
